<div class="container">
  <div class="container-image">
    <img src="/assets/img/amico.svg" alt="send" />
    <div class="text">
      <h1>¡Te acabamos de enviar un email!</h1>
      <span>{{ content }}</span>
    </div>
  </div>
</div>
